.wallboard-link {
    composes: wallboard-link;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: var(--secondary-sidebar-hover-blue);
    display: block;
    margin: 0 16px 16px 16px;
    font-size: 12px;
    padding: 8px 16px;
    cursor: pointer;
}

.wallboard-link:hover,
.wallboard-link:focus {
    background: var(--navy-bg-active-new);
    border-color: rgba(255, 255, 255, 0.1);
}
